var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "price-history-popup", on: { click: _vm.closePopup } },
        [
          _c(
            "div",
            {
              staticClass: "price-history-popup__content",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "price-history-popup__header" }, [
                _c("h3", { staticClass: "price-history-popup__title" }, [
                  _vm._v(
                    "\n        Historia cen - Lokal " +
                      _vm._s(_vm.apartmentId) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "price-history-popup__close",
                    on: { click: _vm.closePopup }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                        })
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-history-popup__body" }, [
                _vm.loading
                  ? _c("div", { staticClass: "price-history-popup__loading" }, [
                      _vm._v("\n        Ładowanie historii cen...\n      ")
                    ])
                  : _vm.error
                  ? _c("div", { staticClass: "price-history-popup__error" }, [
                      _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
                    ])
                  : _vm.priceHistory.length === 0
                  ? _c("div", { staticClass: "price-history-popup__empty" }, [
                      _vm._v(
                        "\n        Brak historii cen dla tego lokalu\n      "
                      )
                    ])
                  : _c(
                      "div",
                      { staticClass: "price-history-popup__table" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._l(_vm.sortedPriceHistory, function(entry, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "price-history-popup__table-row"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "price-history-popup__table-cell"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.formatPrice(entry.price)) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "price-history-popup__table-cell"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.formatPrice(entry.pricePerSqm)
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "price-history-popup__table-cell"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.formatDate(entry.datetime)) +
                                      "\n          "
                                  )
                                ]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "price-history-popup__table-header" }, [
      _c("div", { staticClass: "price-history-popup__table-cell" }, [
        _vm._v("Cena")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price-history-popup__table-cell" }, [
        _vm._v("Cena za m²")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price-history-popup__table-cell" }, [
        _vm._v("Obowiązuje od")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4db063a2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db063a2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/partials/PriceHistoryPopup.vue
// module id = 60
// module chunks = 0